import React from 'react'
import _ from 'lodash'
import { withFormik } from 'formik'

import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import InputTextarea from '../../views/widgets/InputTextarea'
import config from '../../../config'
import GeneralInfoFormLocationContainer from '../general-info/GeneralInfoFormLocationContainer'
import InputTextTagSuggestion from '../general-info/InputTextTagSuggestion'
import InputTags from '../../views/widgets/InputTags'
import HomeButton from '../mobileHome/HomeButton'

const MobileForm = ({
  handleSubmit,
  handleChange,
  handleBlur,
  setFieldValue,
  setValues,
  touched,
  values,
  listings,
  errors,
  language = 'th',
}) => (
  <div>
    {/* <Tags
      label="Town"
      desription={values.town ? values.town.toUpperCase() : '-'}
    /> */}
    <Field label="Title">
      <InputText
        name={`title.${language}`}
        placeholder="Enter your title"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.title[language]}
        error={errors.title && errors.title[language]}
      />
    </Field>
    <Field label="แท็ก">
      <InputTags
        name={`tags`}
        placeholder="Enter your tags"
        onChange={value => {
          setFieldValue('tags', value)
        }}
        values={values.tags}
        error={errors.tags && errors.tags[language]}
        renderInputText={InputTextTagSuggestion}
      />
    </Field>
    <Field label="Notes">
      <InputTextarea
        name="notes"
        placeholder="Enter your notes"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.notes}
        error={errors.notes && errors.notes}
      />
    </Field>

    {/* <Field label="Listing">
        {touched.listing &&
          errors.listing && (
            <React.Fragment>
              <div className="tag is-warning">{errors.listing} </div>
              <br />
            </React.Fragment>
          )}

        <div className={classnames('select', { 'is-warning': errors.listing })}>
          <select
            name="listing"
            component="select"
            onChange={handleChange}
            value={values.listing}
          >
            <option value="">- Select Listing -</option>
            <option value="none"> ไม่แน่ใจ </option>
            {_.map(listings, listing => (
              <option key={listing._id} value={listing._id}>
                {listing.title}
              </option>
            ))}
          </select>
        </div>
      </Field> */}

    <Field label="Location">
      <hr />
      <GeneralInfoFormLocationContainer
        language={language}
        locationInfo={values.location}
        isShowMap={false}
        onLatLngChange={(lat, lng) => {
          setValues({
            ...values,
            location: {
              ...values.location,
              latitude: lat,
              longitude: lng,
            },
          })
        }}
        onLocationChange={({ name, value }) => {
          console.log(name, value)
          setFieldValue(name, value)
        }}
      />
    </Field>

    {/* <Field label="Images">
        <PortalImagesUploader
          imageStores={values.imageStores}
          portalID={values._id}
        />
      </Field> */}

    <nav className="navbar is-fixed-bottom is-info">
      <div className="navbar-end">
        <div className="navbar-item has-text-right">
          <HomeButton />{' '}
          <input
            className="button is-primary"
            onClick={handleSubmit}
            type="submit"
            value="Save"
          />
        </div>
      </div>
    </nav>
  </div>
)

const initDraftedPortal = (portal = {}, listings = []) => {
  return {
    title: config.getLangText(),
    notes: '',
    ...portal,
  }
}

export default withFormik({
  mapPropsToValues: ({ portal, listings }) => {
    return initDraftedPortal(portal, listings)
  },
  handleSubmit: (values, { props, setSubmitting, setErrors, errors }) => {
    console.log(values)
    if (props.onSubmit) {
      props.onSubmit(values)
    }
  },
  validate: values => {
    let errors = {}
    return errors
  },
  enableReinitialize: true,
  // isInitialValid: true,
  displayName: 'MobileForm',
})(MobileForm)



// WEBPACK FOOTER //
// ./src/components/templates/mobileForm/MobileForm.js